<h2>User</h2>
<div class="email">
  <div>Email</div>
  <div>{{ email }}</div>
</div>
<div class="token">
  <div>Access Token</div>
  <textarea readonly>{{ token }}</textarea>
</div>
